import React from "react";

function Introduction() {
  return (
    <div className="p-3 rounded-md border border-solid shadow-md hover:border-green-300">
      <div className="my-5">
        <img
          className="rounded-full w-72 h-72 m-auto outline outline-offset-2 outline-gray-200"
          src="Images/profile_git_hub.jpg"
          alt="profile_image"
        />
      </div>
      <h1 className="my-4 p-4 font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-5xl dark:text-white">
        안녕하세요, <br />
        신입 백엔드 개발자 손부원 입니다{" "}
      </h1>
    </div>
  );
}

export default Introduction;
